import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from './components/Header';
import styles from './Refinements.scss';
import * as actions from '../../app/actions/constants';
import refinementsFromUrl from '../model/refinementsFromUrl';
import getFormattedLocationFromRefinements from '../model/getFormattedLocationFromRefinements';
import getFormattedPrice from './services/getFormattedPrice';
import getFormattedArea from './services/getFormattedArea';
import getFormattedPropertyTypes from './services/getFormattedPropertyTypes';
import { sortOptionPropTypes } from '../model/query/sortOptions';
import { USER_AGENT_PROP_TYPES } from '../../../shared/model/types';

export class Refinements extends Component {
  static contextTypes = {
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
      search: PropTypes.string.isRequired,
    }).isRequired,
    websiteRoot: PropTypes.string,
    userAgent: USER_AGENT_PROP_TYPES.isRequired,
  }

  static getExtraLocalitiesLength(refinements) {
    return (refinements.localities && refinements.localities.length - 1) || 0;
  }

  hideSmartAppBanner = () => {
    const { isiPhone, isSafari } = this.context.userAgent;
    if (isiPhone && isSafari) {
      window.scrollTo({ top: 50 });
    }
  }

  openRefinements = () => {
    const { initialState } = this.props;
    this.hideSmartAppBanner();
    this.props.dispatch({ type: actions.OPEN_REFINEMENT, value: initialState });
  }

  render() {
    const { channelObject, additionalElements, refinementsContainerClass } = this.props;
    const { location } = this.context;
    const refinements = refinementsFromUrl(location.pathname + location.search);
    const firstLocalityFormatted = getFormattedLocationFromRefinements(refinements);
    const extraLocalitiesCount = Refinements.getExtraLocalitiesLength(refinements);
    const propertyTypesString = getFormattedPropertyTypes(refinements);
    const priceString = getFormattedPrice(refinements);
    const areaString = getFormattedArea(refinements);

    return (
      <div className={styles.wrapper}>
        <div className={[styles.container, refinementsContainerClass].join(' ')}>
          <Header
            channelObject={channelObject}
            location={firstLocalityFormatted}
            extraLocalitiesCount={extraLocalitiesCount}
            propertyTypesString={propertyTypesString}
            priceString={priceString}
            areaString={areaString}
            openRefinements={this.openRefinements}
          />
          {additionalElements}
        </div>
      </div>
    );
  }
}

export const refinementProps = {
  channel: PropTypes.string,
  energyEfficiency: PropTypes.number,
  numParkingSpaces: PropTypes.number,
  sortObject: PropTypes.shape(sortOptionPropTypes),
  searchWithin: PropTypes.string,
  tenureType: PropTypes.string,
  keywords: PropTypes.string,
  propertyTypes: PropTypes.array,
  onSubmit: PropTypes.func,
  minPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  maxPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  minFloorArea: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  maxFloorArea: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  minSiteArea: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  maxSiteArea: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  locations: PropTypes.arrayOf(PropTypes.string),
};

Refinements.propTypes = {
  channelObject: PropTypes.shape({
    shortHumanReadable: PropTypes.string.isRequired,
  }).isRequired,
  initialState: PropTypes.object,  // eslint-disable-line
  dispatch: PropTypes.func.isRequired,
  additionalElements: PropTypes.arrayOf(PropTypes.element),
  refinementsContainerClass: PropTypes.string,
};

export default connect()(Refinements);
